"use strict";
/**
 * @copyright
 * Copyright (c) 2022 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.QueryParameter = void 0;
var QueryParameter = /** @class */ (function () {
    function QueryParameter(parameter) {
        this._parameter = parameter;
    }
    // See https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/encodeURIComponent
    QueryParameter._fixedEncodeURIComponent = function (str) {
        return encodeURIComponent(str).replace(/[!'()*]/g, function (c) {
            return "%" + c.charCodeAt(0).toString(16);
        });
    };
    QueryParameter.prototype.encode = function () {
        return (this._parameter
            // For some reason, the URL that gets pushed into the URL box on the browser
            // is decoded. This is ok, to an extent, but then we try to decode as
            // part of loading the search results, and hit a decode error because
            // the encoding is gone at that point.
            .replace("%", " percent ")
            .trim()
            .replace(/\s+/g, " ")
            // Due to differences in PHP and Node URL encoding single quotes can cause issues.
            // Strip them out as they aren't relevant to user searches
            .replace("'", "")
            // We don't want to double encode spaces. Treat them as a special case
            .split(" ")
            .map(function (word) { return QueryParameter._fixedEncodeURIComponent(word); })
            .join(" "));
    };
    return QueryParameter;
}());
exports.QueryParameter = QueryParameter;
//# sourceMappingURL=QueryParameter.js.map